import { FC, useState } from "react"
import { CURRENCY } from "@/store/apis/balanceAPI"
import { useGetLabrUserBalanceQuery } from "@/store/apis/userAPI"
import type { IWithdrawalCoin } from "@/store/apis/withdrawalAPI"
import styles from "./WithdrawTab.module.scss"
import { OperationsList, WithdrawBalanceCard, WithdrawForm } from "./ui"

const BALANCE_CURRENCIES: readonly IWithdrawalCoin[] = [
  CURRENCY.TON,
  CURRENCY.STAR
]

export const WithdrawTab: FC = () => {
  const { data: labrBalance, isLoading } = useGetLabrUserBalanceQuery()
  const [selectedCurrency, setSelectedCurrency] =
    useState<IWithdrawalCoin | null>(null)

  if (selectedCurrency) {
    return (
      <div className={styles.WithdrawTab}>
        <WithdrawForm
          currency={selectedCurrency}
          balance={labrBalance?.[selectedCurrency] ?? 0}
          onCancel={() => setSelectedCurrency(null)}
        />
      </div>
    )
  }

  return (
    <div className={styles.WithdrawTab}>
      <div className={styles.WithdrawTab_balances}>
        {BALANCE_CURRENCIES.map((currency) => (
          <WithdrawBalanceCard
            key={currency}
            currency={currency}
            amount={labrBalance?.[currency] ?? 0}
            isLoading={isLoading}
            onWithdraw={setSelectedCurrency}
          />
        ))}
      </div>
      <OperationsList />
    </div>
  )
}
